import { render } from "./LocateModal.vue?vue&type=template&id=7cb36726"
import script from "./LocateModal.vue?vue&type=script&lang=js"
export * from "./LocateModal.vue?vue&type=script&lang=js"

import exportComponent from "/home/smartphone/public_html/production/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__